import { Component, inject, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { AuthService } from '../../../../services/API/auth.service/auth.service';
import { ToastrService } from 'ngx-toastr';
import { isPlatformBrowser, NgIf } from '@angular/common';
import { AuthContainerComponent } from '../../../../shared/components/auth-container/auth-container.component';
import { OtpVerificationComponent } from '../otp-verification/otp-verification.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { ICountry, NgxCountriesDropdownModule } from 'ngx-countries-dropdown';
import { AVAILABLE_COUNTRY_CODES } from '../../../../models/constant/constants';
@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, AuthContainerComponent, NgIf, OtpVerificationComponent, ButtonComponent, NgxCountriesDropdownModule, ReactiveFormsModule],
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent {
  selectedDialCode = "+91";
  inputValue: string = ''; // Input field value
  isInputValid: boolean = false; // Validity of input
  showIcon: boolean = false; // Controls icon visibility
  inputType: 'email' | 'mobile' = 'email'; // Automatically detected input type (email or phone)
  isVerify: boolean | null = false;
  email: string = '';
  mobileNumber: string | number = '';
  errorMessage: string = ''; // Error message to show when input is invalid


  availableCountries = AVAILABLE_COUNTRY_CODES;
  uniqueAvailableCodes = this.availableCountries.filter(el => el !== 'ca');
  // TemporaryForm
  private platformId = inject(PLATFORM_ID);
  form: FormGroup;
  constructor(
    private route: Router,
    private authService: AuthService,
    private toastr: ToastrService,

    // Temporary
    private fb: FormBuilder,
  ) {

    // Temporary
    this.form = this.fb.group({
      email: ["", [Validators.required, Validators.email]]
    })
  }

  ngAfterViewInit() {
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {

        const elements = document.querySelectorAll('.ipv_country-name');
        elements.forEach(el => {
          const match = el.textContent?.match(/^(.+?)\s\(.+\)$/);
          if (match) {
            el.textContent = match[1]; // just the English name
          }
        });
      }
    }, 100);
  }

  determineInputType(): void {
    const phoneLikeRegex = /^\+?\d+$/; // Allows optional '+' at the start, followed by digits
    if (phoneLikeRegex.test(this.inputValue)) {
      this.inputType = 'mobile';
      this.inputValue = this.inputValue.replace("+", "");
    } else {
      this.inputType = 'email';
    }
  }


  validateInput(): void {
    return;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Strict email validation
    const phoneRegex = /^\d+$/; // Strict phone validation

    this.determineInputType(); // Set input type before validation

    if (this.inputType === 'mobile') {
      if (this.inputValue.length < 6 || this.inputValue.length > 15) {
        this.isInputValid = false;
        this.errorMessage = this.inputValue.length < 6
          ? 'Phone number should have at least 6 digits'
          : 'Phone number cannot be more than 15 digits';
      } else {
        this.isInputValid = true;
        this.errorMessage = '';
      }
    } else if (this.inputType === 'email') {
      if (!emailRegex.test(this.inputValue)) {
        this.isInputValid = false;
        this.errorMessage = 'Please enter a valid email.';
      } else {
        this.isInputValid = true;
        this.errorMessage = '';
      }
    } else {
      this.isInputValid = false;
      this.errorMessage = 'Invalid input.';
    }

    // Show icon only if the input is valid
    this.showIcon = !!this.inputValue;
  }

  // Handle the Next button click
  onNext(): void {
    // if (this.isInputValid) {
    // const loginFilter = this.inputType.toUpperCase() as 'EMAIL' | 'MOBILE';
    // let input = loginFilter === "MOBILE" ? `${this.selectedDialCode}-${this.inputValue}` : this.inputValue; 
    this.form.markAllAsTouched()
    if (this.form.valid) {
      // Temporary
      let loginFilter: "EMAIL" = 'EMAIL';
      let input = this.form.controls["email"].value
      // Call the AuthService to perform the sign-in API request
      this.authService.signIn(loginFilter, input).subscribe({
        next: (response) => {
          this.email = response.data.email;
          this.mobileNumber = response.data.mobileNumber;
          this.toastr.success(response.message);
          this.isVerify = true; // Show the OTP verification component
        },
        error: (error) => {
          console.error('Error during sign-in:', error);
          this.toastr.error(error.error.message);
        },
      });
    } else {
      this.toastr.error('Enter a valid input.');
      this.isVerify = false;
    }
  }

  // Navigate to Sign Up
  onSignUp(): void {
    console.log('Navigating to Sign Up...');
    this.route.navigateByUrl('auth/signup');
  }

  // Receive data from OTP verification child component
  receiveData(data: boolean) {
    this.isVerify = data; // Handle the data received from the child
  }


  selectedCountryConfig = {
    hideCode: true,
    hideName: true,
    hideFlag: false,
  };

  countryListConfig = {
    hideCode: true,
    hideName: true,
    hideFlag: false,
  };


  onCountryChange(country: ICountry) {
    this.selectedDialCode = country.dialling_code || "";
  }
}
